// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__jWbFD","list":"styles_list__VdTOs"};